import { clsx } from 'clsx';
import { isSafari } from '../../../utils/browser';

export const PROSE_LINK_CLASSNAMES =
  'prose-a:no-underline prose-a:text-brand-tertiary hover:prose-a:text-brand-secondary active:prose-a:text-brand-secondary hover:prose-a:underline';

export const MARKDOWN_CLASSNAMES = clsx(
  `max-w-none prose dark:prose-invert
  prose-strong:font-semibold prose-strong:text-[var(--prose-strong-text,inherit)] 
  prose-headings:font-semibold prose-headings:text-[var(--prose-headings-text,inherit)] 
  prose-h1:text-2xl prose-h2:text-xl prose-h3:text-lg
  prose-p:font-normal prose-p:m-0 
  prose-hr:my-md 
  ${PROSE_LINK_CLASSNAMES}
  break-anywhere`,
  // In safari, table layouting algorithm is buggy, which causes unwanted breaking of table header content in new line. So, disabling wrapping for table header cells in safari
  { 'prose-th:whitespace-nowrap': isSafari() },
);
